import PlayerUpdates from "@/components/updates/PlayerUpdates";

export default function UpdatesPage() {
  return <PlayerUpdates />;
}